import { defineComponent as B, provide as L, getCurrentInstance as R, inject as y, ref as T, onBeforeUnmount as b } from "vue";
import { getSlot as x } from "./highrise719.mjs";
import { getScrollParent as P } from "./highrise1380.mjs";
import { off as l, on as d } from "./highrise632.mjs";
import { beforeNextFrameOnce as V } from "./highrise1381.mjs";
const k = B({
  name: "Binder",
  props: {
    syncTargetWithParent: Boolean,
    syncTarget: {
      type: Boolean,
      default: !0
    }
  },
  setup(u) {
    var n;
    L("VBinder", (n = R()) === null || n === void 0 ? void 0 : n.proxy);
    const c = y("VBinder", null), s = T(null), m = (e) => {
      s.value = e, c && u.syncTargetWithParent && c.setTargetRef(e);
    };
    let t = [];
    const p = () => {
      let e = s.value;
      for (; e = P(e), e !== null; )
        t.push(e);
      for (const v of t)
        d("scroll", v, a, !0);
    }, f = () => {
      for (const e of t)
        l("scroll", e, a, !0);
      t = [];
    }, o = /* @__PURE__ */ new Set(), h = (e) => {
      o.size === 0 && p(), o.has(e) || o.add(e);
    }, w = (e) => {
      o.has(e) && o.delete(e), o.size === 0 && f();
    }, a = () => {
      V(z);
    }, z = () => {
      o.forEach((e) => e());
    }, r = /* @__PURE__ */ new Set(), S = (e) => {
      r.size === 0 && d("resize", window, i), r.has(e) || r.add(e);
    }, g = (e) => {
      r.has(e) && r.delete(e), r.size === 0 && l("resize", window, i);
    }, i = () => {
      r.forEach((e) => e());
    };
    return b(() => {
      l("resize", window, i), f();
    }), {
      targetRef: s,
      setTargetRef: m,
      addScrollListener: h,
      removeScrollListener: w,
      addResizeListener: S,
      removeResizeListener: g
    };
  },
  render() {
    return x("binder", this.$slots);
  }
});
export {
  k as default
};
